export default __webpack_public_path__ + "assets/ff4d6cb5ec933416b3bfd62e02765aba.svg";